<template>
  <div>
    <label v-if="label" class="block text-sm mb-2 opacity-60" :for="name">
      {{ label }}
    </label>
    <div class="relative pb-2 w-full">
      <input
        ref="inputEl"
        :id="id"
        :autocomplete="autocomplete"
        :autocorrect="autocorrect ? 'on' : 'off'"
        :placeholder="placeholder"
        :readonly="readonly"
        :required="required"
        :type="currentType"
        :name="name"
        :value="formatted"
        :inputmode="inputMode"
        @focus="inputFocus"
        @blur="inputBlur"
        @change="emitEvent('change', $event)"
        @input="emitEvent('update:modelValue', $event)"
        @paste="enforceFormat"
        @keydown="enforceFormat"
        class="bg-transparent focus:outline-none w-full px-0 py-2 font-medium text-lg"
      />
      <div class="absolute bottom-0 left-0 right-0 h-0.5 transition-opacity"
           :class="!isFocused && 'opacity-50'"
           :style="invertedColors"/>
    </div>
  </div>
</template>

<script setup>
import {inject, onMounted, computed, onBeforeUnmount} from "vue";
import {useInput} from "../composables/InputComponent";

const emit = defineEmits(["update:modelValue", "change", "input-blur", "input-focus"]);
const props = defineProps({
  customId: String,
  label: String,
  labelHint: String,
  placeholder: String,
  modelValue: [String, Number],
  type: String,
  required: Boolean,
  error: String,
  format: String,
  maxLength: Number,
  autocomplete: String,
  autofocus: Boolean,
  roundedFull: Boolean,
  readonly: Boolean,
  inputClasses: String,
  inputContainerClasses: String,
  labelClasses: String,
  inputMode: String,
  notRoundedLeft: Boolean,
  copy: Boolean,
  prefix: String,
  prefixes: Array,
  autocorrect: Boolean,
  dark: Boolean,
  name: String,
});

const {
  id,
  inputEl,
  isFocused,
  currentType,
  formatted,
  enforceFormat,
  inputBlur,
  inputFocus,
  emitEvent,
} = useInput(props, emit);

const typeformData = inject("typeformData", {});
const invertedColors = computed(() => `background: ${typeformData.primaryForeground};color:${typeformData.primaryBackground};--placeholder-color:${typeformData.primaryForeground};`);

const handleFocus = () => {
  if (!inputEl || !inputEl.value) return;
  inputEl.value.focus();
};

onMounted(() => {
  if (props.autofocus) setTimeout(handleFocus, 200);
  window.addEventListener("focus", handleFocus);
});

onBeforeUnmount(() => window.removeEventListener("focus", handleFocus));
</script>


<style scoped>
input::placeholder {
  color: var(--placeholder-color);
  opacity: 0.4;
}
</style>
